import { get } from "lodash";
import styled from "styled-components";
import React from "react";
import { courts } from "@upsolve/shared";

import ImageStaticMap from "../Media/ImageStaticMap";

const CourtsList = ({ district, state }) => {
  if (district == null && state == null) return null;
  return (
    <div>
      {courts
        .filter((c) => {
          if (state) return c.address.state.match(new RegExp(state, "i"));
          if (district) return c.district.match(new RegExp(district, "i"));
          return true;
        })
        .map((court) => (
          <CourtListItem key={`${court.address.state}-${court.name}`}>
            <ImageStaticMap alt={court.name} {...court.coordinates} height={120} width={120} zoom={11} />
            <p>
              <b>
                <a href={court.url}>{court.name}</a>
              </b>
              <br />
              {court.phone}
              <br />
              {get(court, "address.display")}
            </p>
          </CourtListItem>
        ))}
    </div>
  );
};

const CourtListItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 1em;
  & > img {
    height: 120px;
    width: 120px;
    max-width: 120px;
    border-radius: 8px;
  }
  p {
    margin: 1em;
  }
`;

export default CourtsList;
